module.exports = __webpack_public_path__ + "static/media/icons_Bilan AVC - Hémiplégie.1baec794.svg";